/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\MultiLanguage\TranslationWrapper.ts
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Thursday June 8th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Thursday June 8th 2023 2:03:19 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import Translator from "MultiLanguage/Translation";

/**
 * Factory to create translation instance Object
 * @param {Object} target The instance of translation
 */
const TranslatorFactory = (target: Translator) => ({
  setLanguage: (language: string) => target.setLanguage(language),
  getLanguage: () => target.getLanguage(),
  getAvailableLanguages: () => target.getAvailableLanguages(),
  decode: (treePosition: string) => {
    try {
      return target.decode(treePosition);
    } catch {
      return treePosition;
    }
  },
});

const translator = TranslatorFactory(new Translator());

export default translator;
